var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAndroidStudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    id: "android-studio",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 11,
    fill: "#94C856"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6E6E6E",
    d: "M16 28C9.383 28 4 22.617 4 16S9.383 4 16 4s12 5.383 12 12-5.383 12-12 12zm0-22C10.486 6 6 10.486 6 16s4.486 10 10 10 10-4.486 10-10S21.514 6 16 6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "m24.857 26.763-3.12-5.2A7.97 7.97 0 0 0 24 16a1 1 0 0 0-2 0 5.973 5.973 0 0 1-1.338 3.77L19 17l-2 1 1.936 3.227A5.957 5.957 0 0 1 16 22a5.948 5.948 0 0 1-2.931-.782L15 18l-2-1-5.857 9.763a.991.991 0 0 0-.143.514v.914a.5.5 0 0 0 .724.447l1.016-.508c.17-.085.312-.217.41-.38l2.893-4.822A7.931 7.931 0 0 0 16 24a7.941 7.941 0 0 0 3.964-1.06l2.886 4.811c.098.163.24.295.41.38l1.016.508a.5.5 0 0 0 .724-.448v-.914a.991.991 0 0 0-.143-.514z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#6E6E6E",
    d: "M19 11h-1V9a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v2h-1a1 1 0 0 0-1 1v4c0 .334.167.646.445.832l3 2a1 1 0 0 0 1.11 0l3-2c.278-.186.445-.498.445-.832v-4a1 1 0 0 0-1-1zm-3 5a2 2 0 1 1-.001-3.999A2 2 0 0 1 16 16z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidStudio);
export default __webpack_public_path__ + "static/media/android-studio.ca2e3760dd72a4c8ef168e73e664501b.svg";
export { ForwardRef as ReactComponent };